module.exports = __webpack_public_path__ + "img/PL08136.12afd478.png";